import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    documentos: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_INFORME_BY_ID_CLIENTE = 'GET_INFORME_BY_ID_CLIENTE'
const GET_INFORME_BY_ID_INSTALACION = 'GET_INFORME_BY_ID_INSTALACION'
const GET_DICTAMEN_BY_ID_CLIENTE = 'GET_DICTAMEN_BY_ID_CLIENTE'
const GET_ESCRITO_BY_ID_CLIENTE = 'GET_ESCRITO_BY_ID_CLIENTE'
const GET_SOLICITUD_BY_ID_FC01 = 'GET_SOLICITUD_BY_ID_FC01'
const GET_DICTAMEN_BY_TIPO = 'GET_DICTAMEN_BY_TIPO'
//*******************************************************************************************************************


//MÉTODOS 

export const obtenerInformesByIdCliente = createAsyncThunk(
    GET_INFORME_BY_ID_CLIENTE,
    async (idcliente) => {
        try {
            const fullUrl = host + `Fi25Documentos/obtenerInformesByIdCliente/${idcliente}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerInformesByIdInstalacion = createAsyncThunk(
    GET_INFORME_BY_ID_INSTALACION,
    async (id) => {
        try {
            const fullUrl = host + `Fi25Documentos/obtenerInformesByIdInstalacion/${id}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerDictamenByIdCliente = createAsyncThunk(
    GET_DICTAMEN_BY_ID_CLIENTE,
    async (idcliente) => {
        try {
            const fullUrl = host + `Fi25Documentos/obtenerDictamenByIdCliente/${idcliente}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerEscritoByIdCliente = createAsyncThunk(
    GET_ESCRITO_BY_ID_CLIENTE,
    async (idcliente) => {
        try {
            const fullUrl = host + `Fi25Documentos/obtenerEscritoByIdCliente/${idcliente}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerDictamenByTipo = createAsyncThunk(
    GET_DICTAMEN_BY_TIPO,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Documentos/obtenerDictamenByTipo`
            const res = await axios.post(fullUrl, data)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerSolicitudByIdSolicitudFC01 = createAsyncThunk(
    GET_ESCRITO_BY_ID_CLIENTE,
    async (idcliente) => {
        try {
            const fullUrl = host + `Fi25Documentos/obtenerSolicitudByIdFc01/${idcliente}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosDocumentosSlice = createSlice({

    name: 'metodosDocumentosSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerInformesByIdCliente.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.documentos = payload.data.data

        },
        [obtenerDictamenByTipo.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.documentos = payload.data.data

        },
        [obtenerInformesByIdInstalacion.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.documentos = payload.data.data

        },
        [obtenerDictamenByIdCliente.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.documentos = payload.data.data
        },
        [obtenerEscritoByIdCliente.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.documentos = payload.data.data
        },
        [obtenerSolicitudByIdSolicitudFC01.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.documentos = payload.data.data
        },
    },

})


export const { } = metodosDocumentosSlice.actions
export const Fi25DocumentosReducer = metodosDocumentosSlice.reducer